import { Outlet } from 'react-router-dom';
// @mui
import { Container, Stack } from '@mui/material';
// components
import Logo from '../components/Logo';

// ----------------------------------------------------------------------

export default function AuthLayout() {
  return (
    <Container maxWidth="sm">
      <Stack sx={{ minHeight: '100vh', py: 6 }} justifyContent="center">
        <Stack alignItems="center" sx={{ mb: 5 }}>
          <Logo />
        </Stack>
        <Outlet />
      </Stack>
    </Container>
  );
}
